
import React, {Component} from 'react';
import {Button,Modal,ButtonToolbar} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import {Checkbox} from 'react-icheck'
import {connect} from 'react-redux'
class ExportExcelButton extends Component {

  constructor(...args){
    super(...args)
    this.refTableId = 'export-stock-'+Math.ceil(Math.random()*100);
    let data = []
    if (process.env.NODE_ENV == "development") {
      //data = [{itemnum:1,detail:"test",productcode:'abc',quantity:'10'}]
    }
    this.state = {show:false,data:data,oneFill:false}
  }
  
  clearItem(){
    this.setState({data:[]}) 
  }

  addItem(nItem){
    let {data} = this.state
    
    let foundItem = false
    data.map((item,index)=>{
      if(item.itemnum===nItem.itemnum){
        foundItem = true
      }
      return item
    })
    if(!foundItem)
      data.push(nItem)
    this.setState({data:data})    
  }

  removeItem(rItem){
    let {data} = this.state
    data = data.reduce((rresult,item)=>{
      if(item.itemnum!==rItem.itemnum){
        rresult.push(item)
      }
      return rresult
    },[])
    this.setState({data:data})
  }

  onClick(){
    this.setState({show:true})
  }

  onHide(){
    this.setState({show:false})    
  }

  onTextChange(index,key,e){
    let {data} = this.state
    data[index][key] = {value:e.target.value}
    this.setState({data:data})
  }

  onTextBlur(index,key,colValue){
    let {data} = this.state
    data[index][key] = colValue.value
    this.setState({data:data})
  }

  onColumnClick(index,key,colValue){
    let {data} = this.state
    let value = (typeof colValue.value !=='undefined')?colValue.value:colValue   
    data[index][key] = {value:value}
    this.setState({data:data})
  }

  onOKClick(){
    this.setState({show:false})   
    let {messages} = this.props
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), messages['Warehouse List']+".xlsx")
  
  }

  onDeleteClick(index,e){
    let {data} = this.state
    data.splice(index,1)
    this.setState({data:data})
  }

  onOneCheckbox(e,value){
    // console.log(e,value)
    let {data} = this.state
    data = data.map((item,index)=>{
      if(value){
        if(item.quantity*1===0){
          item['preQuantity'] = item.quantity
          item.quantity = 1        
        }
      }else{
        item.quantity = item.preQuantity
      }
      return item
    })
    this.setState({data:data,oneFill:value})
  }

  

  renderInputColumn(item,index,key){
    if(item!==null && item!==undefined &&  item.value !==undefined)
      return (<input autoFocus
        style={{display:'inline-block'}}
        className='form-control text-left'
        value={item.value}
        onBlur={ this.onTextBlur.bind(this,index,key,item) }
        onChange={ this.onTextChange.bind(this,index,key) }
      />)
    return (
      <div>{item}</div>
    )
  }

  renderRowData(){
    let {messages} = this.props
    let {data} = this.state
    if(data.length===0){
      return (<tr><td colSpan={5}>{messages['No Item']}</td></tr>)
    }
    return data.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td>{item.productcode}</td>
        <td onClick={this.onColumnClick.bind(this,index,'detail',item.detail)}>
          {this.renderInputColumn(item.detail,index,'detail')}</td>
        <td className='text-center' onClick={this.onColumnClick.bind(this,index,'quantity',item.quantity)}>
          {this.renderInputColumn(item.quantity,index,'quantity')}</td>
        <td><Button bsStyle={'danger'} onClick={this.onDeleteClick.bind(this,index)}>{messages['Delete']}</Button></td>
      </tr>
    ))
  }

  renderTable(){
    let {messages} = this.props
    return (
      <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'150px'}}>{messages['Product Code/Barcode']}</th>
            <th>{messages['Part Name']}</th>            
            <th className='text-center' style={{width:'50px'}}>{messages['Quantity/Item']}</th>
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderDeleteTable(){
    let {data} = this.state
    let {messages} = this.props
    return (
      <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item,index)=>(
            <tr key={index}>
              <td><Button bsStyle={'danger'} onClick={this.onDeleteClick.bind(this,index)}>{messages['Delete']}</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  renderReportPopup(){
    let {show,oneFill} = this.state
    let {messages} = this.props
    return (
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{messages['Download Excel File']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box >
            <Box.Body>
              <Checkbox 
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label={' '+messages['Add 1 For Item as 0']}
                value={oneFill}
                onChange={this.onOneCheckbox.bind(this)}
              />
              {this.renderTable()}              
            </Box.Body>           
          </Box>          
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onOKClick.bind(this)}><FontAwesome name='download'/>&nbsp;{messages['Download File']}</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;{messages['Cancel']}</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>  
    )
  }

  render(){
    let {data} = this.state
    let {showBtn,messages} = this.props
    return (
      <div style={{display:(data.length>0)?'inline':'none'}}>
        {showBtn?<Button className='bg-green' onClick={this.onClick.bind(this)}>{data.length} {messages['Excel File']}</Button>:''}
        {this.renderReportPopup()}
      </div>
    )
  }
}

ExportExcelButton.defaultProps = {
  showBtn:true
}
export default connect(
  (state) => ({messages: state.message.view.stock.ExportExcelButton}),null,null,{withRef:true},
)(ExportExcelButton);





// WEBPACK FOOTER //
// ./src/view/stock/ExportExcelButton.js